function PinchIcon() {
	return (
		<svg
			width="90"
			height="91"
			viewBox="-5 15 95 91"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<ellipse
				cx="38.6094"
				cy="28.957"
				rx="12.0654"
				ry="12.0654"
				fill="url(#paint0_radial_391_2160)"
			/>
			<ellipse
				cx="25.3374"
				cy="72.3926"
				rx="12.0654"
				ry="12.0654"
				fill="url(#paint1_radial_391_2160)"
			/>
			<g>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M7.43384 29.8582C9.86856 28.6204 12.6878 26.8533 14.837 25.0899C14.944 25.0035 15.0608 24.9813 15.19 25.0116C15.3192 25.042 15.4229 25.1283 15.4713 25.2388C16.611 27.7744 18.3519 30.5999 19.9696 32.7892C20.1009 32.9688 20.1273 33.1733 20.0424 33.3764C19.8298 33.8594 19.1214 34.6598 18.6213 34.8894C18.4265 34.98 18.2096 34.9538 18.0292 34.8247C17.4259 34.3856 16.6083 33.6979 15.8272 32.9072C15.1127 35.528 14.0863 39.0547 13.4337 41.0951C13.3413 41.3832 13.101 41.5623 12.8143 41.5693C12.4018 41.584 11.8829 41.5242 11.3426 41.3973C10.8023 41.2704 10.311 41.0931 9.94823 40.8964C9.69462 40.7625 9.56185 40.4834 9.60455 40.196C9.91651 38.0756 10.5787 34.4634 11.1053 31.7985C10.054 32.159 9.01574 32.4109 8.28003 32.5356C8.06104 32.571 7.85513 32.4978 7.72102 32.33C7.37539 31.9018 7.09718 30.8698 7.1218 30.3427C7.13621 30.123 7.25357 29.9398 7.44835 29.8492L7.4366 29.8465L7.43384 29.8582Z"
					fill="#F7B907"
				>
					<animateTransform
						attributeName="transform"
						attributeType="XML"
						type="translate"
						values="-3 10; 0 0;-3 10"
						dur="1s"
						repeatCount="indefinite"
					/>
				</path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M1.68353 54.3487C3.31292 56.5407 5.03934 59.3752 6.18183 61.8991C6.23923 62.0242 6.33391 62.096 6.46312 62.1263C6.59232 62.1566 6.72357 62.1255 6.81611 62.0481C8.96526 60.2847 11.7818 58.5292 14.2048 57.2887C14.4023 57.1863 14.5169 57.015 14.5313 56.7953C14.5559 56.2681 14.2777 55.2361 13.9321 54.8079C13.798 54.6401 13.5921 54.567 13.3731 54.6023C12.6374 54.727 11.5991 54.979 10.5478 55.3394C11.0744 52.6745 11.7248 49.0596 12.0486 46.9419C12.094 46.6428 11.9585 46.3755 11.7049 46.2416C11.3421 46.0448 10.8508 45.8675 10.3105 45.7406C9.77015 45.6138 9.25129 45.5539 8.83885 45.5686C8.55214 45.5757 8.30905 45.7664 8.21936 46.0428C7.55501 48.0805 6.54041 51.6099 5.8259 54.2307C5.04485 53.44 4.22723 52.7523 3.6239 52.3132C3.44353 52.1841 3.22658 52.1579 3.0318 52.2485C2.53172 52.4781 1.82327 53.2785 1.61071 53.7615C1.52583 53.9647 1.54942 54.1809 1.68353 54.3487Z"
					fill="#F7B907"
				>
					<animateTransform
						attributeName="transform"
						attributeType="XML"
						type="translate"
						values="0 0; -3 10; 0 0"
						dur="1s"
						repeatCount="indefinite"
					/>
				</path>
			</g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M50.156 104.052C50.3732 104.861 51.1091 105.392 51.9055 105.392V105.416C52.0623 105.416 52.2192 105.404 52.376 105.355C53.3412 105.09 53.9083 104.101 53.6549 103.135L51.8089 96.258C51.7003 95.8357 51.447 95.4737 51.085 95.2324L25.0237 77.4359C22.8278 75.9398 22.2607 72.9355 23.7568 70.7396L24.4445 69.7261C25.9406 67.5302 28.9449 66.9631 31.1409 68.4592L36.703 72.2357C37.1374 72.5373 37.6803 72.6218 38.1871 72.4891L38.5128 72.4046C42.3858 71.367 44.6903 67.3733 43.6527 63.5003L35.1828 31.8768C34.5916 29.6206 35.9308 27.304 38.175 26.7007C39.273 26.4112 40.4071 26.556 41.3844 27.123C42.3617 27.678 43.0615 28.595 43.3511 29.6809L50.7834 57.4314C51.0488 58.3966 52.0382 58.9758 53.0034 58.7103C53.9687 58.4449 54.5357 57.4555 54.2824 56.4903L51.2427 45.1408L58.041 45.3067C58.0074 45.5411 58.0191 45.786 58.083 46.0294L61.2079 57.6846C61.4251 58.493 62.1611 59.0238 62.9574 59.0238C63.1143 59.0238 63.2711 59.0118 63.428 58.9635C64.3932 58.6981 64.9603 57.7087 64.7069 56.7435L61.6642 45.3951L68.5112 45.5622C68.4666 45.8142 68.4746 46.0797 68.5438 46.3434L71.6446 57.9383C71.8618 58.7466 72.5978 59.2775 73.3941 59.2775C73.5509 59.2775 73.7078 59.2655 73.8646 59.2172C74.8299 58.9518 75.3969 57.9624 75.1436 56.9972L72.109 45.6499L78.7631 45.8123L86.304 73.9368L81.9122 87.1364C81.7916 87.4743 81.7795 87.8362 81.876 88.174L83.722 95.0513C83.9386 95.8573 84.6709 96.3875 85.4645 96.3906L85.4595 96.3906H85.4715L85.4645 96.3906C85.6197 96.3903 85.7748 96.378 85.93 96.3303C86.8953 96.0648 87.4623 95.0755 87.209 94.1102L85.5077 87.7638L89.8995 74.5642C90.0202 74.2264 90.0323 73.8644 89.9357 73.5266L81.9122 43.5681C81.7071 42.7959 81.0194 42.253 80.211 42.2289L50.2662 41.4951L46.85 28.7398C46.3071 26.7128 45.004 25.0237 43.1942 23.974C41.3844 22.9243 39.2609 22.6468 37.246 23.1897C33.0713 24.3118 30.5738 28.6192 31.6959 32.7938L40.1658 64.4173C40.6484 66.203 39.7073 68.049 38.0302 68.7367L33.192 65.4549C29.3431 62.8247 24.0826 63.8261 21.4644 67.6629L20.7766 68.6764C18.1464 72.5253 19.1478 77.7858 22.9846 80.404L48.4909 97.8265L50.156 104.052Z"
				fill="#F0F1F5"
			/>
			<defs>
				<radialGradient
					id="paint0_radial_391_2160"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(38.6094 28.957) rotate(90) scale(12.0654)"
				>
					<stop stop-color="#FFB2BA" />
					<stop offset="1" stop-color="#E82F41" />
				</radialGradient>
				<radialGradient
					id="paint1_radial_391_2160"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(25.3374 72.3926) rotate(90) scale(12.0654)"
				>
					<stop stop-color="#FFB2BA" />
					<stop offset="1" stop-color="#E82F41" />
				</radialGradient>
			</defs>
		</svg>
	);
}

export default PinchIcon;
